import { Button, Card, Container, Grid, Typography } from '@mui/material';
import './services.css';
import {
	PeopleAlt as PeopleAltIcon,
	TouchApp as TouchAppIcon,
	SavedSearch as SavedSearchIcon,
	Style as StyleIcon,
	KeyboardArrowRight as KeyboardArrowRightIcon,
	ListAlt as ListAltIcon,
	Dashboard as DashboardIcon,
	SupportAgent as SupportAgentIcon,
	Settings as SettingsIcon,
	Code as CodeIcon,
	Security as SecurityIcon,
	ShoppingCartCheckout as ShoppingCartCheckoutIcon,
} from '@mui/icons-material';

import Slider from 'react-slick';
import ServiceBtn from './servicesReusableComponets/ServiceBtn';
import Header from './Header';
import TopSection from '../resuableComponents/servicesReusableComponets/TopSection';
import Features from '../resuableComponents/servicesReusableComponets/Features';
import Eccomerce from '../resuableComponents/servicesReusableComponets/Eccomerce';

const Service = () => {
	// const singleSliderObj = [
	//   {
	//     index: 1,
	//     titlecard: "An Online Store Selling Outfits & Accessories",
	//     imgsrc: "https://www.webguru-india.com/assets/images/ecommerce-website-design-services-thetoplove-big.webp",
	//     desctext:
	//       "We developed the eCommerce website for the leading fashion brand RENE. Built with Magento, the single-domain multi-store supports multi-currency. Some of its features include SMS alert, newsletter, online payment gateway (CCAvenue, Razorpay) etc.",
	//   },
	//   {
	//     index: 2,
	//     titlecard: "An Ecommerce Website Selling Tea",
	//     imgsrc: "https://www.webguru-india.com/assets/images/ecommerce-website-design-services-mymbt.webp",
	//     desctext:
	//       "The online store built for Glenburn Fine Tea offers fresh seasonal tea sourced from Assam & Darjeeling estates. Developed with Magento, the e-store is rich with features like automatic IP tracking, currency changer, payment gateway (PayUMoney, PayPal), etc.",
	//   }
	// ];

	// const settings = {
	//   lazyLoad: "ondemand",
	//   slidesToShow: 1,
	//   slidesToScroll: 1,
	//   autoplay: true,
	//   autoplaySpeed: 5000,
	//   dots: true,
	// };

	return (
		<>
			<Header />
			<TopSection />
			<Eccomerce />

			<div style={{ marginTop: '20px' }}>
				<Grid container spacing={0} alignItems='center'>
					{/* Image Section */}
					<Grid
						item
						xs={12}
						md={6}
						sx={{
							display: { xs: 'none', md: 'block' },
						}}>
						<img
							src='https://www.webguru-india.com/assets/images/ecommerce-website-design-services-app-banner.jpg'
							alt='eCommerce App'
							style={{ width: '100%' }}
							height={202}
						/>
					</Grid>

					{/* Content Section */}
					<Grid
						item
						xs={12}
						md={6}
						style={{
							background: '#2f1b56',
							color: 'white',
							padding: '20px',
						}}>
						<Typography
							variant='h4'
							gutterBottom
							sx={{ marginBottom: '16px', fontWeight: 'bold' }}>
							eCommerce Mobile App
						</Typography>
						<Typography variant='body1' sx={{ marginBottom: '20px' }}>
							If you’re looking to take your eCommerce business to the next
							level, why not try a mobile app? We build cutting-edge, secure,
							and user-friendly eCommerce apps that will truly transform your
							conversion rates.
						</Typography>

						<Grid container alignItems='center' spacing={1}>
							<Grid item xs={12} md={4}>
								<Typography
									variant='body1'
									sx={{ fontWeight: 'bold', fontSize: '20px' }}>
									Call us on{' '}
									<a href='tel:147852390' style={{ color: '#ffb74d' }}>
										0147826223
									</a>
								</Typography>
							</Grid>
							<Grid item xs={12} md={6}>
								<Button
									variant='contained'
									sx={{
										color: 'primary',
									}}>
									More About Ecommerce Apps
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</div>

			<div>
				<Container>
					<Typography
						variant='h4'
						gutterBottom
						sx={{
							marginTop: '20px',
						}}>
						Platforms Used by Our eCommerce Website Developers
					</Typography>

					<Grid container spacing={6} alignItems='center'>
						<Grid item xs={12} md={6}>
							<Typography
								variant='h6'
								sx={{
									marginTop: '20px',
								}}>
								<img
									src='https://www.webguru-india.com/assets/images/ecommerce-website-design-services-node-icon.png'
									alt=''
								/>
								Custom Development
							</Typography>
							<p>
								Do you want your online marketplace to stand out from the crowd,
								and packed with features and functionalities specific to your
								business? Hire Webguru Infosystems - the best ecommerce website
								development company in Kolkata. The services of our experienced
								eCommerce website developers are just what you need. We can
								craft a feature-rich, easily navigable, user-friendly, and
								lightweight custom eCommerce website tailored to your business.
								We use frameworks like Laravel and NodeJS to develop robust and
								scalable online stores.
							</p>
						</Grid>
						<Grid item xs={12} md={6}>
							<Typography
								variant='h6'
								sx={{
									marginTop: '20px',
								}}>
								<img
									src='https://www.webguru-india.com/assets/images/ecommerce-website-design-services-opencart-icon.png'
									alt=''
								/>
								OpenCart Development
							</Typography>
							<p>
								One of the main perks of OpenCart is easy customization. Thanks
								to the use of AJAX, websites developed using OpenCart are
								extremely lightweight. It supports over 14000 extensions that
								can be plugged-in effectively to enhance functionalities of the
								online store. As a reputable eCommerce website development
								company in Kolkata, we can help you create a beautiful online
								store at a reasonable cost.
							</p>
						</Grid>
					</Grid>
					<ServiceBtn
						quickEnquiryText='Get A Free Quote'
						seeOurWorkText='Meet Our Team '
						onQuickEnquiry={() => console.log('Contact Us clicked')}
						onSeeOurWork={() => console.log('Portfolio clicked')}
					/>
				</Container>
			</div>

			{/* <Container>
      <div className="main-sec">
      <div className="slide-sec">
        <Slider {...settings}>
          {singleSliderObj.map((slide) => (
            <div key={slide.index}>
              <div className="singlecard">
              
                <div className="singlecard-header">
                  <img
                    src={slide.imgsrc}
                    alt={slide.titlecard}
                    style={{ width: "100%", height: "auto" }}
                  />
                </div>
                
                <div className="singlecard-body">
                  <div className="singlecard-content">
                    <div className="singlecard-title">
                      <Typography
                      variant="h5"
                      sx={{
                        marginTop: "20px",
                      }}
                    >{slide.titlecard}</Typography>
                    </div>
                    <div className="singlecard-text">
                      <p style={{ fontSize: "1rem" }}>{slide.desctext}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
    <div style={{display:'flex' , justifyContent:'center'}}>
    <ServiceBtn quickEnquiryText="View Portfolio"
        seeOurWorkText="Contact Us"
        onQuickEnquiry={() => console.log("Contact Us clicked")}
        onSeeOurWork={() => console.log("Portfolio clicked")} />
    </div>
    </Container> */}

			<div>
				<Container>
					<Typography
						variant='h4'
						sx={{
							marginTop: '20px',
						}}>
						Multivendor Marketplace Development
					</Typography>
					<p>
						If you’re looking for an eCommerce web development company that
						specialize in developing feature-rich and highly optimized
						multivendor marketplaces, we can help! With attractive user
						interfaces, seamless data management, top-notch security measures,
						and insightful analytics, we have successfully delivered several
						marketplace solutions for both startups and established enterprises.
						Our experience and use of cutting-edge technologies ensure that your
						dream marketplace will encourage vendor participation and high
						customer engagement. Our platform is highly scalable and designed to
						grow with your business while adhering to the best security
						protocols. Discover the benefits of our multivendor eCommerce
						marketplace features:
					</p>
					<Grid container spacing={6} alignItems='center'>
						<Grid item xs={12} md={2}>
							<TouchAppIcon
								sx={{ fontSize: '28px', color: '#613da7', marginRight: '8px' }}
							/>
							<p>Vendor Registration & Management</p>
						</Grid>
						<Grid item xs={12} md={2}>
							<StyleIcon
								sx={{ fontSize: '28px', color: '#613da7', marginRight: '8px' }}
							/>
							<p>Vendor Registration & Management</p>
						</Grid>
						<Grid item xs={12} md={2}>
							<SavedSearchIcon
								sx={{ fontSize: '28px', color: '#613da7', marginRight: '8px' }}
							/>
							<p>Vendor Registration & Management</p>
						</Grid>
						<Grid item xs={12} md={2}>
							<SavedSearchIcon
								sx={{ fontSize: '28px', color: '#613da7', marginRight: '8px' }}
							/>
							<p>Vendor Registration & Management</p>
						</Grid>
						<Grid item xs={12} md={2}>
							<SavedSearchIcon
								sx={{ fontSize: '28px', color: '#613da7', marginRight: '8px' }}
							/>
							<p>Vendor Registration & Management</p>
						</Grid>
						<Grid item xs={12} md={2}>
							<SavedSearchIcon
								sx={{ fontSize: '28px', color: '#613da7', marginRight: '8px' }}
							/>
							<p>Vendor Registration & Management</p>
						</Grid>
					</Grid>
				</Container>
			</div>

			<div
				style={{
					marginTop: '30px',
					background: '#f2f2f2',
					paddingTop: '10px',
					paddingBottom: '10px',
				}}>
				<Container>
					<Grid container spacing={6} alignItems='center'>
						<Grid item xs={12} md={8}>
							<Typography
								variant='h4'
								sx={{
									marginTop: '20px',
								}}>
								Custom eCommerce Website and App
							</Typography>
							<p>
								Ready to take your business to new heights? Say goodbye to the
								limitations of generic platforms and hello to eCommerce websites
								and apps tailored to your specific business requirements. With
								responsive eCommerce solutions, you can capture the growing
								mobile market. Webguru Infosystems is the most searched
								eCommerce website development company in India. Our team ensures
								that your website and app work flawlessly across multiple
								devices, allowing your company to be accessible to customers on
								the go. We believe in working together. From concept to
								completion, our team works closely with you, keeping you
								informed and involved at all times. The combination of your
								vision and our expertise ensures a successful and impactful
								eCommerce solution.
							</p>
						</Grid>
						<Grid item xs={12} md={4}>
							<img
								src='https://i.ytimg.com/vi/FXz1OdZaiiY/hqdefault.jpg'
								alt='dd'
							/>
						</Grid>
					</Grid>
				</Container>
			</div>

			<Features />

			<section className='section-6'>
				<Container>
					<Typography variant='h4' sx={{ marginTop: '10px' }}>
						Core Features of Our eCommerce Website Design Services
					</Typography>
					<p>
						The success of an eCommerce website depends on the features and
						functionalities it offers. As a trusted eCommerce website
						development company in India, we offer all the essential features
						required for a successful online store. Starting from a rich UI/UX
						to cross-device friendly coding for seamless access across the
						mobile, tablet, desktop and laptop - our eCommerce web developers
						take care of it all. Besides, all our eCommerce portals are
						developed with the option to scale up as the business grows.
					</p>
					<Grid container spacing={6} style={{ marginTop: '10px' }}>
						{/* Card 1 */}
						<Grid item xs={12} md={2}>
							<Card
								variant='outlined'
								sx={{
									textAlign: 'center',
									padding: '20px',
									background: '#f5f5f5',
									borderRadius: '10px',
									boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
									height: '202px',
								}}>
								<div>
									<ListAltIcon
										sx={{
											fontSize: '50px',
											color: '#0171d7',
											marginBottom: '10px',
										}}
									/>
								</div>
								<Typography
									variant='h6'
									sx={{
										fontWeight: 'bold',
										color: '#333',
									}}>
									Content Management Capabilities
								</Typography>
							</Card>
						</Grid>

						{/* Card 2 */}
						<Grid item xs={12} md={2}>
							<Card
								variant='outlined'
								sx={{
									textAlign: 'center',
									padding: '20px',
									background: '#f5f5f5',
									borderRadius: '10px',
									boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
									height: '202px',
								}}>
								<div>
									<DashboardIcon
										sx={{
											fontSize: '50px',
											color: '#e91e63',
											marginBottom: '10px',
										}}
									/>
								</div>
								<Typography
									variant='h6'
									sx={{
										fontWeight: 'bold',
										color: '#333',
									}}>
									Dashboard View
								</Typography>
							</Card>
						</Grid>

						{/* Card 3 */}
						<Grid item xs={12} md={2}>
							<Card
								variant='outlined'
								sx={{
									textAlign: 'center',
									padding: '20px',
									background: '#f5f5f5',
									borderRadius: '10px',
									boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
									height: '202px',
								}}>
								<div>
									<SettingsIcon
										sx={{
											fontSize: '50px',
											color: '#4caf50',
											marginBottom: '10px',
										}}
									/>
								</div>
								<Typography
									variant='h6'
									sx={{
										fontWeight: 'bold',
										color: '#333',
									}}>
									Customization Options
								</Typography>
							</Card>
						</Grid>

						{/* Card 4 */}
						<Grid item xs={12} md={2}>
							<Card
								variant='outlined'
								sx={{
									textAlign: 'center',
									padding: '20px',
									background: '#f5f5f5',
									borderRadius: '10px',
									boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
									height: '202px',
								}}>
								<div>
									<CodeIcon
										sx={{
											fontSize: '50px',
											color: '#ff9800',
											marginBottom: '10px',
										}}
									/>
								</div>
								<Typography
									variant='h6'
									sx={{
										fontWeight: 'bold',
										color: '#333',
									}}>
									Developer Tools
								</Typography>
							</Card>
						</Grid>

						{/* Card 5 */}
						<Grid item xs={12} md={2}>
							<Card
								variant='outlined'
								sx={{
									textAlign: 'center',
									padding: '20px',
									background: '#f5f5f5',
									borderRadius: '10px',
									boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
									height: '202px',
								}}>
								<div>
									<SecurityIcon
										sx={{
											fontSize: '50px',
											color: '#9c27b0',
											marginBottom: '10px',
										}}
									/>
								</div>
								<Typography
									variant='h6'
									sx={{
										fontWeight: 'bold',
										color: '#333',
									}}>
									Security Features
								</Typography>
							</Card>
						</Grid>

						{/* Card 6 */}
						<Grid item xs={12} md={2}>
							<Card
								variant='outlined'
								sx={{
									textAlign: 'center',
									padding: '20px',
									background: '#f5f5f5',
									borderRadius: '10px',
									boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
									height: '202px',
								}}>
								<div>
									<SupportAgentIcon
										sx={{
											fontSize: '50px',
											color: '#ff5722',
											marginBottom: '10px',
										}}
									/>
								</div>
								<Typography
									variant='h6'
									sx={{
										fontWeight: 'bold',
										color: '#333',
									}}>
									Support Services
								</Typography>
							</Card>
						</Grid>
						<Grid item xs={12} md={2}>
							<Card
								variant='outlined'
								sx={{
									textAlign: 'center',
									padding: '20px',
									background: '#f5f5f5',
									borderRadius: '10px',
									boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
									height: '202px',
								}}>
								<div>
									<ShoppingCartCheckoutIcon
										sx={{
											fontSize: '50px',
											color: '#ff5722',
											marginBottom: '10px',
										}}
									/>
								</div>
								<Typography
									variant='h6'
									sx={{
										fontWeight: 'bold',
										color: '#333',
									}}>
									Easy-to-Use Checkout
								</Typography>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</section>
		</>
	);
};

export default Service;
